export { default as SaVoucherSlot } from './SaVoucherSlot';
